import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { PurchaseOrderComponent } from '../purchase-order/purchase-order.component';
import { NgDialogAnimationService } from 'src/app/services/core/ng-dialog-animation.service';

@Component({
    selector: 'app-add-purchase-order-sidebar',
    templateUrl: './add-purchase-order-sidebar.component.html',
    styleUrls: ['./add-purchase-order-sidebar.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AddPurchaseOrderSidebarComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AddPurchaseOrderSidebarComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AddPurchaseOrderSidebarComponent implements OnInit {
  public poForm!: UntypedFormGroup;
  public step: any;

  constructor(public dialogRef: MatDialogRef<AddPurchaseOrderSidebarComponent>,
    public dialog: NgDialogAnimationService) {}

  addPurchaseOrderObject:any={
    selectedType:'regular',
    jobId:null,
    jobDetail:null,
    job_name:''
  }

  ngOnInit(): void {
  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  close = (data: any = '') => {
    this.dialogRef.close(data);
  }

  onStepChanged = (event: any, stepper: any) => {
    // this.step = { event: event, stepper: stepper };
    // console.log('event', this.poForm.value);
  }

  save() {
    let modalData: any = {
      type: this.addPurchaseOrderObject.selectedType
    };

    // If vendor-based PO
    if (this.addPurchaseOrderObject.selectedType === 'vendor') {
      console.log('Creating vendor-based PO from sidebar');

      modalData.fromVendorQuote = true;
      modalData.preSelectVendor = {
        id: this.addPurchaseOrderObject.vendorId,
        vendor_id: this.addPurchaseOrderObject.vendorId,
        name: this.addPurchaseOrderObject.vendorName || this.addPurchaseOrderObject.vendorDetail?.vendor_name
      };

      console.log('Vendor data for PO modal:', modalData.preSelectVendor);
    } else {
      // Job-based PO (regular or bulk)
      modalData.jobId = this.addPurchaseOrderObject.jobId;
      modalData.job_name = this.addPurchaseOrderObject.job_name;
      modalData.jobDetail = this.addPurchaseOrderObject.jobDetail;
    }

    const dialogRef = this.dialog.open(PurchaseOrderComponent, {
      width: '95%',
      minHeight: '80%',
      maxWidth: '100vw',
      data: modalData
    });

    dialogRef.afterClosed().subscribe(result => {
     if (result == 'close') {
        this.dialogRef.close('close')
      }
    });
  }



  

}
